@if (gridView) {
<div class="grid-card d-flex justify-content-between flex-column h-100" [class.is-select]="selectMode"
  [class.is-saved]="wishlist">
  <!-- Product Image + Compare -->
  <a [routerLink]="enableCompare || selectMode ? null : getProductUrl(item.urlSlug)" [queryParams]="currentSearch ? {q: currentSearch} : null"
    class="product-card-link" (click)="onProductCardClick($event, item, i)">
    <div [class.imageShadow]="enableCompare" class="product-img">
      <img class="card-image" [class.placeholder-img]="!item.imageUrl" [src]="item.imageUrl || 'placeholder.svg'" alt="" width="220" height="168" loading="lazy" />

      <img *ngIf="enableCompare" class="compareCheck" [src]="
            isItemInCompareList(item) ? './checkBoxBtn.svg' : './uncheckBox.svg'
          " alt="" loading="lazy" />

      <div class="max-compare-text" *ngIf="
            enableCompare &&
            compareList.length >= 4 &&
            clickedCompareIndex === i &&
            !isItemInCompareList(item)
          ">
        Max 4 items
      </div>
    </div>

    <!-- Product Info -->
    <div class="cardDiv">
      <div class="name my-2">
        <span>{{ item.productName }}</span>
      </div>
      <div *ngIf="isLogin" class="price">
        <span>${{ item?.price?.toFixed(2) }}</span>
      </div>
      <div *ngIf="!isLogin" class="off-price">
        <span>Login to see price</span>
      </div>

      <!-- Saved Items' design has no "More Options" chip. -->
      <div class="specification" *ngIf="!selectMode && !wishlist">
        <div class="spec d-flex">
          <p [style.visibility]="item.colors?.length || item.enabledSpecs?.length
                  ? 'visible'
                  : 'hidden'
              " class="me-3">
            More Options
          </p>
        </div>
      </div>

      <!-- Product Status -->
      <div class="p-status mb-1" *ngIf="!selectMode">
        <span class="status quotes" *ngIf="item?.inventoryQty === false && item?.productStatus === 3">
          <span class="dot"></span>Request Quote
        </span>
        <span class="status out-stock" *ngIf="
              item?.inventoryQty === false &&
              item?.productStatus !== 3 &&
              item?.productStatus !== 4 &&
              item?.productStatus !== 0
            ">
          <span class="dot"></span>Out of stock
        </span>
        <span class="status discontinued" *ngIf="item?.productStatus === 4 || item?.productStatus === 0">
          <span class="dot"></span>Discontinued
        </span>
        <span class="status in-stock" *ngIf="
              item?.inventoryQty > 0 &&
              (item?.productStatus === 3 ||
                item?.productStatus === 2 ||
                item?.productStatus === 1)
            ">
          <span class="dot" style="visibility: hidden"></span>
        </span>
      </div>
    </div>
  </a>

  <!-- Picker mode replaces the cart row -->
  <div class="selectBtnDiv" *ngIf="selectMode">
    <button type="button" class="select-button" (click)="productSelect.emit(item)">Select</button>
  </div>

  <!-- Cart & Quantity -->
  <div (mouseenter)="
        resetTooltip();
        checkForMobileAndQuote(item)
          ? ''
          : !item.istwice
            ? toggleQuantityVisibility(item.urlSlug, isLogin, item)
            : aleradyInCartOnHover()
      " class="d-flex justify-content-between align-items-center cartBtnDiv"
    *ngIf="!selectMode && !showQuantityState[item.urlSlug]?.visible && item?.productStatus !== 4 && item?.productStatus !== 0">
    <a (click)="!isLogin ? showLoginPopup(false) : (item.istwice) ? openMobileCartPopup($event) : (item.productStatus !== 4 && item.productStatus !== 0 ? handleRequestQuoteClick(item) : null)"
      class="card-button tooltip-container">
      <!-- [ngClass]="{ 'disabled-link': !isLogin, inCartBtn: item.istwice }" -->
      <ng-container *ngIf="isLogin && item?.cartQty > 0; else notInCart">
        {{ item.cartQty + " Added" }}
        <img [ngClass]="item.istwice ? 'hide' : ''" style="height: 15px; width: 15px; padding: 0"
          src="/images/svg/cart.svg" alt="" />
      </ng-container>
      <ng-template #notInCart>
        {{ getTagName(item) }}
        <img style="height: 15px; width: 15px; padding: 0" src="/images/svg/cart.svg" alt="" loading="lazy" />
      </ng-template>
      <div [ngClass]="{ 'd-none':  (showLogin && !wishlistLogin)  || isRequestQuote(item) || hideTooltip }"
        class="tooltip-text" [ngClass]="{ tooltip: (showLogin && wishlistLogin) || hideTooltip }">
        {{ getLockedProductTooltip(item) }}
      </div>
    </a>
  </div>

  <div *ngIf="!selectMode && showQuantityState[item.urlSlug]?.visible && item?.productStatus !== 4 && item?.productStatus !== 0"
    (mouseleave)="out(item.urlSlug)" class="quantityDiv d-flex justify-content-between align-items-center">
    <div class="d-flex justify-content-center input-group align-items-center">
      <div class="d-flex qty align-items-center justify-content-evenly w-100">
        <img [src]="
              item.cartQty != 1 ? './minus-icon-blue.svg' : './remove-qty.svg'
            " (click)="
              isRequestQuote(item)
                ? updateMinusQuotes(item)
                : handleMinus(item, $event)
            " alt="minus-icon" loading="lazy" />
        <div class="d-flex align-items-center">
          <input *ngIf="!isRequestQuote(item)" id="qty-input-{{item.urlSlug}}" class="m-0 qty-input" type="number"
            (keyup)="handlePlus(item, $event, true)" [style.width]="getInputWidth(item.cartQty)"
            [(ngModel)]="item.cartQty" />
          <label for="qty-input-{{item.urlSlug}}" class="m-0">{{ isRequestQuote(item) ? (item.quoteQty || 0) + " ADDED"
            :
            "ADDED"}}</label>
        </div>
        <img src="./plus-icon-blue.svg" (click)="
              isRequestQuote(item)
                ? addToQuote(item)
                : handlePlus(item, $event)
            " alt="plus-icon" loading="lazy" />
      </div>
    </div>
  </div>

  <!-- Compare -->
  <div class="comp d-none" (click)="onClickCompare(item)" (mouseenter)="resetTooltip()">
    <div class="d-flex justify-content-between align-items-center">
      <div class="tooltip-container">
        <input type="radio" class="circle me-1" [checked]="isItemInCompareList(item)" />
        <span>Compare</span>
        <div [ngClass]="{'d-none': hideTooltip}" class="tooltip-text">
          {{
          isItemInCompareList(item)
          ? "Remove from compare"
          : "Add to compare"
          }}
        </div>
      </div>
    </div>
  </div>

  <!-- Wishlist -->
  <div class="favt" (mouseenter)="resetTooltip()" (click)="
            $event.stopPropagation(); $event.preventDefault();
            isLogin ? onClickWishlist(item, $event, isLogin) : showLoginPopup()
          ">
    <div class="tooltip-container">
      <img [src]="
            item.isWishlisted || item.customerWishListId
              ? '/images/svg/red-favt.svg'
              : '/images/svg/favt.svg'
          " alt="" loading="lazy" />
      <div class="tooltip-text" [ngClass]="{ tooltip: (showLogin && wishlistLogin) || hideTooltip }">
        {{ getLockedWishlistTooltip(item) }}
      </div>
    </div>
  </div>



</div>
} @else {
<a class="d-flex inner-card product-card-link" [routerLink]="enableCompare ? null : getProductUrl(item.urlSlug)"
    [queryParams]="currentSearch ? {q: currentSearch} : null" (click)="onProductCardClick($event, item, i)">
  <div class="image-Outer-div" [class.imageShadow]="enableCompare">
    <img class="p-img" [class.placeholder-img]="!item.imageUrl" [src]="item.imageUrl || 'placeholder.svg'" alt="" width="180" height="176" loading="lazy" />
    <img *ngIf="isItemInCompareList(item) && enableCompare" class="compareCheck" src="./checkBoxBtn.svg" alt=""
      loading="lazy" />
    <img *ngIf="!isItemInCompareList(item) && enableCompare" class="compareCheck" src="./uncheckBox.svg" alt=""
      loading="lazy" />
    <div class="favt mob-Favt" (mouseenter)="resetTooltip()">
      <div class="tooltip-container">
        <img [src]="
              item.isWishlisted || item.customerWishListId
                ? '/images/svg/red-favt.svg'
                : '/images/svg/favt.svg'
            " alt="" (click)="
              $event.stopPropagation(); $event.preventDefault();
              isLogin ? onClickWishlist(item, $event, isLogin) : showLoginPopup()
            " loading="lazy" />
        <div class="tooltip-text" [ngClass]="{ tooltip: (showLogin && wishlistLogin) || hideTooltip }">
          {{ getLockedWishlistTooltip(item) }}
        </div>
      </div>
    </div>
  </div>
  <div class="favt pc-Favt" (mouseenter)="resetTooltip()">
    <div class="tooltip-container">
      <img [src]="
              item.isWishlisted || item.customerWishListId
                ? '/images/svg/red-favt.svg'
                : '/images/svg/favt.svg'
            " alt="" (click)="
              $event.stopPropagation(); $event.preventDefault();
              isLogin ? onClickWishlist(item, $event, isLogin) : showLoginPopup()
            " loading="lazy" />
      <div class="tooltip-text" [ngClass]="{ tooltip: (showLogin && wishlistLogin) || hideTooltip }">
        {{ getLockedWishlistTooltip(item) }}
      </div>
    </div>
  </div>

  <div class="name">
    <div class="nameDiv">
      <div>
        <span class="itemName">{{ item.productName }}</span>
        <div class="price mt-2" *ngIf="isLogin">
          <span>${{ item?.price?.toFixed(2) }}</span>
        </div>
         <div *ngIf="!isLogin" class="off-price">
        <span>Login to see price</span>
      </div>
      </div>
      <div class="specification">
        <div class="spec d-flex">
          <p [style.visibility]="
                item.colors?.length || item.enabledSpecs?.length
                  ? 'visible'
                  : 'hidden'
              " class="me-3">
            More Options
          </p>
        </div>
      </div>
      <div class="p-status mb-1">
        <span class="status quotes" *ngIf="item?.inventoryQty === false && item?.productStatus === 3">
          <span class="dot"></span>Request Quote
        </span>
        <span class="status out-stock" *ngIf="
              item?.inventoryQty === false &&
              item?.productStatus !== 3 &&
              item?.productStatus !== 4 &&
              item?.productStatus !== 0
            ">
          <span class="dot"></span>Out of stock
        </span>
        <span class="status discontinued" *ngIf="item?.productStatus === 4 || item?.productStatus === 0">
          <span class="dot"></span>Discontinued
        </span>
        <span class="status in-stock" *ngIf="
              item?.inventoryQty > 0 &&
              (item?.productStatus === 3 ||
                item?.productStatus === 2 ||
                item?.productStatus === 1)
            ">
          <span class="dot" style="visibility: hidden"></span>
        </span>
      </div>
    </div>
    <div *ngIf="item?.productStatus !== 4 && item?.productStatus !== 0"
      class="grid-view-button button d-flex justify-content-end flex-column align-items-center">
      <div [ngClass]="{
           'disabled-link': !isLogin,
            inCartActive: item.istwice
          }"
        (click)="$event.stopPropagation(); $event.preventDefault(); isLogin ? ((item.istwice) ? openMobileCartPopup($event) : (item.productStatus !== 4 && item.productStatus !== 0 ? handleRequestQuoteClick(item) : null)) : showLoginPopup(false)"
        class="cart card-button mb-lg-2 d-flex justify-content-between align-items-center addtocart tooltip-container"
        style="width: 240px; margin-top: 15px"
        (mouseenter)="resetTooltip(); hoveredIndex = i; item.istwice && !checkForMobileAndQuote(item) ? aleradyInCartOnHover() : null"
        (mouseleave)="hoveredIndex = -1">
        <span [class.hidden]="item.istwice" class="sign qty"
          (click)="isRequestQuote(item) ? updateMinusQuotes(item) : handleMinus(item, $event)" *ngIf="isLogin"
          [style.visibility]="checkForMobileAndQuote(item) ? 'hidden' : null">
          <img src="/minus-icon-blue.svg" alt="" loading="lazy" />
        </span>
        <ng-container *ngIf="isLogin && item?.cartQty > 0; else notInCart">
          <span *ngIf="item.istwice; else singleInCart">Multiple in cart</span>
          <ng-template #singleInCart>
            <div class="list-view-quantity d-flex align-items-center">
              <input *ngIf="!isRequestQuote(item)" id="qty-input-{{item.urlSlug}}-list" class="m-0 qty-input"
                type="number" (keyup)="handlePlus(item, $event, true)" [style.width]="getInputWidth(item.cartQty)"
                [(ngModel)]="item.cartQty" (click)="$event.stopPropagation()" />
              <label for="qty-input-{{item.urlSlug}}-list" class="m-0" (click)="$event.stopPropagation()">{{
                isRequestQuote(item) ?
                (item.quoteQty || 0) + " ADDED" : "ADDED"}}</label>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #notInCart>
          {{ getTagName(item) }}
        </ng-template>
        <span [class.hidden]="item.istwice" class="sign qty"
          (click)="isRequestQuote(item) ? addToQuote(item) : handlePlus(item, $event)" *ngIf="isLogin"
          [style.visibility]="checkForMobileAndQuote(item) ? 'hidden' : null">
          <img src="/plus-icon-blue.svg" alt="" loading="lazy" />
        </span>
        <div [ngClass]="{ 'd-none': (showLogin && !wishlistLogin) || isRequestQuote(item) || hideTooltip }"
          class="tooltip-text">
          {{ getLockedProductTooltip(item) }}
        </div>
      </div>
    </div>
  </div>
</a>
}

<div #loginPopup [ngClass]="{'right-align': !gridView}" *ngIf="showLogin && !isLogin && wishlistLogin"
  class="LoginPopup">
  <a type="button" class="btn-close" (click)="showLogin = false"></a>
  <span class="loginFont">Log in to save favorites for quick reordering.</span>
  <a class="loginBtn popup-cta" routerLink="/login">LOG IN</a>
  <a class="registerBtn popup-cta mb-0" routerLink="/register">Create Account</a>
</div>

<div #loginPopup [ngClass]="{'right-align-bottom': !gridView}" *ngIf="showLogin && !isLogin && !wishlistLogin"
  class="LoginPopup bottom-attached">
  <span class="loginFont">Log in to add to cart.</span>
  <button class="registerBtn" (click)="showLogin = false">KEEP SHOPPING</button>
  <a class="loginBtn popup-cta" routerLink="/login">LOG IN</a>
  <span class="loginFont m-0 mt-1">No account? <a routerLink="/register" class="registerBtn border-0"
      (click)="showLogin = false">Create
      one</a></span>
</div>